import { jsonldFacebook } from './JsonldStore';

export const updateJsonldFacebook = (value) => jsonldFacebook.update((oldValue) => value);
